<template>
  <div
    v-if="bestPrice?.price && !withoutPrice"
    :class="{
      'price-savings-fi': true,
      'price-savings-fi--is-mobile': isMobile,
      'price-savings-fi--stroke-price-absolute': strokePriceAbsolute,
      [`price-savings-fi--theme-${theme}`]: theme,
    }"
    data-test="price-savings"
  >
    <price-savings-in-percent-fi
      v-if="!hideSavingsInPercent && savingsInformation"
      class="price-savings-fi__price-savings-in-percent"
      :best-price="bestPrice"
    />

    <div
      :class="{
        'price-savings-fi__price': true,
        'price-savings-fi__price--stroke': savingsInformation,
      }"
      data-test="price-savings-price"
    >
      <div
        v-if="useEco"
        class="price-savings-fi__eco-wrapper"
      >
        <div class="price-savings-fi__eco-label">
          {{ dict.get('checkout.Cart.Sum') }}
        </div>
        <span
          v-if="savingsInformation"
          class="price-savings-fi__price-stroke"
          data-test="price-savings-price-stroke"
        >
          {{ savingsInformation.totalStrokePriceValueFormatted }}
        </span>
        <div class="price-savings-fi__eco-price">
          {{ bestPrice.price.totalValueFormatted }}
        </div>
      </div>
      <template v-else>
        <template v-if="showTotalPicePrefix">
          {{ `${dict.get('product-List.Table.Total')} ${bestPrice.price.totalValueFormatted}` }}
        </template>
        <template v-else>
          {{ bestPrice.price.totalValueFormatted }}
        </template>
        <span
          v-if="savingsInformation"
          class="price-savings-fi__price-stroke"
        >
          {{ savingsInformation.totalStrokePriceValueFormatted }}
        </span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import PriceSavingsInPercentFi from '@/components/atoms/price-savings-in-percent-fi/PriceSavingsInPercentFi.vue';
import { useDict, useFischer } from '@/composables/fischerPlugin';

interface SavingsInformation {
  totalStrokePriceValueFormatted?: string | null;
  [key: string]: any;
}

interface Price {
  totalValueFormatted?: string | null;
  savingsInformation?: SavingsInformation | null;
  [key: string]: any;
}

interface BestPrice {
  price?: Price | null;
  [key: string]: any;
}

interface Props {
  bestPrice?: BestPrice | null;
  isMobile?: boolean;
  theme?: string | null;
  hideSavingsInPercent?: boolean;
  showTotalPicePrefix?: boolean;
  strokePriceAbsolute?: boolean;
  useEco?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  bestPrice: null,
  isMobile: false,
  theme: null,
  hideSavingsInPercent: false,
  showTotalPicePrefix: false,
  strokePriceAbsolute: false,
  useEco: false,
});

const fischer = useFischer();

const savingsInformation = computed(() => props.bestPrice?.price?.savingsInformation);

const withoutPrice = computed(() => fischer.shop.hasPurchasePermissionWithoutPrices());
const dict = useDict();
</script>

<style scoped src="./price-savings-fi" />
